import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import store from "../store";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/welcome",
    name: "Welcome",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Welcome.vue"),
  },
  {
    path: "/chakra-list",
    name: "Chakra",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Chakra/index.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/get-lookups",
    name: "GetLookups",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Chakra/getLookups.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/what-we-do",
    name: "WhatWeDo",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/WhatWeDo/list.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/what-we-do/translations/:id",
    name: "WhatWeDoTranslations",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/WhatWeDo/translations.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/splash",
    name: "Splash",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Splash/list.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/splash/translations/:id",
    name: "SplashTranslations",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Splash/translations.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dailyContent",
    name: "DailyContent",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contents/DailyContent.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/weeklyContent",
    name: "WeeklyContent",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contents/WeeklyContent.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/monthlyContent",
    name: "MonthlyContent",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contents/MonthlyContent.vue"),
    meta: {
      requiresAuth: true,
    },
  },
   {
    path: "/house-content",
    name: "BirthChartHouseContent",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contents/BirthChartHouseContent.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/natalContent",
    name: "natalContent",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contents/NatalContent.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/aspectContent",
    name: "aspectContent",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contents/AspectContent.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/astrologs",
    name: "astrologs",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Astrologs.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/contentLookUp",
    name: "contentLookUp",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ContentLookUp.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/testAstrologyAPI",
    name: "testAstrologyAPI",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/TestAstrologyAPI.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  { 
    path: "/discover/affirmations",
    name: "discoverAffirmations",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Discover/Affirmations.vue")
  },
  { 
    path: "/discover/suggestions",
    name: "discoverSuggestions",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Discover/Suggestions.vue")
  },
  { 
    path: "/dailySuggestion",
    name: "dailySuggestion",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Contents/DailySuggestion.vue")
  },
  { 
    path: "/users",
    name: "users",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Users.vue")
  },
  { 
    path: "/questions",
    name: "Questions",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/QuestionsPage.vue")
  },
  { 
    path: "/biorhythm",
    name: "Biorhythm",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Contents/Biorhythm.vue")
  },
  { 
    path: "/public-figures",
    name: "Public Figures",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/PublicFigures.vue")
  },
  {
    path: "/users/public-figures",
    name: "Users Public Figures",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Users/PublicFigures.vue")
  },
  {
    path: "/rag-list",
    name: "Rag List",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Rag/RagList.vue")
  },
  {
    path: "/rag-images",
    name: "Report Images",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Rag/ReportImages.vue")
  },
  {
    path: "/rag-images/:id/:language",
    name: "ReportImages",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Rag/ReportImages.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/relationship-type-list",
    name: "RelationshipTypeList",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Rag/RelationshipTypeList.vue")
  },
  { 
    path: "/celestial-cards",
    name: "Celestial Cards",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Contents/CelestialCards.vue")
  },
  { 
    path: "/cosmic-events",
    name: "Cosmic Events",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Contents/CosmicEvents.vue")
  },
  { 
    path: "/images",
    name: "Images",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Contents/Images.vue")
  },
  { 
    path: "/stories",
    name: "Stories",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Contents/Stories.vue")
  },
  {
    path: "/upload-story",
    name: "UploadStory",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Stories/UploadStory.vue")
  },
  { 
    path: "/calendar",
    name: "Calendar",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Contents/Calendar.vue")
  },
  { 
    path: "/yearly",
    name: "Yearly",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Contents/YearlyContent.vue")
  },
  {
    path: "/upload-country-city",
    name: "UploadCountryCity",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/CountryCity/UploadCountryCity.vue")
  },
  {
    path: "/give-extra-credit",
    name: "GiveExtraCredit",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Celestia/GiveExtraCredit.vue")
  },
  {
    path: "/question-templates",
    name: "QuestionTemplates",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/QuestionTemplates/list.vue")
  },
  {
    path: "/customize-contents",
    name: "CustomizeContent",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/CustomizeContent/list.vue")
  },
  {
    path: "/preview-create",
    name: "PreviewCreate",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/CustomizeContent/previewCreate.vue")
  },
  {
    path: "/text-editor",
    name: "TextEditor",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Admin/textEditor.vue")
  },
  {
    path: "/cache-delete",
    name: "CacheDelete",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Admin/cacheDelete.vue")
  },
  {
    path: "/mongo-cache-collection",
    name: "MongoCacheCollection",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Admin/mongo-cache-collection.vue")
  },
  {
      path: "/content-upload",
      name: "ContentUploadList",
      component: () =>
          import("../views/Contents/ContestUpload/list.vue")
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.state.token) {
      next("welcome");
    } else {
      next(); // go to wherever I'm going
    }
  } else {
    next(); // does not require auth, make sure to always call next()!
  }
});

export default router;
